/**
 * Implements a clickable list item
 * @param  
 * @returns 
 */
const Card = ({ title, icon, lock, onClick, additinalClass }: any) =>
  (<div className={`connect_modal__contents__card ${lock ? 'connect_modal__contents__card--lock' : ''}`} onClick={onClick}>
    <img className={`icon ${additinalClass}`} src={icon} />
    <div className="text">{title}</div>
  </div>);

export default Card;